export const IMPERSONATION_FLAG_KEYS = ['is_impersonated_session', 'impersonator_id'] as const;

export type ImpersonationSessionFlags = {
    is_impersonated_session: true;
    impersonator_id: string;
};

export function resolveImpersonationSessionFlags(
    impersonatorUser: { id: number } | undefined | null
): ImpersonationSessionFlags | null {
    if (impersonatorUser?.id == null) {
        return null;
    }

    return {
        is_impersonated_session: true,
        impersonator_id: String(impersonatorUser.id),
    };
}
